module.exports = __webpack_public_path__ + "img/sakuya izayoi lunar war servant_sc2.2e24230e.png";